<div class="pagination-controls">

  <!-- Prev -->
  <button
    class="pagination-button prev"
    [disabled]="currentPage() === 1"
    (click)="goToPage(currentPage() - 1)">
    ‹
  </button>

  <!-- First + ellipsis -->
  @if (pages().length && pages()[0] > 1) {
    <button class="pagination-button" (click)="goToPage(1)">1</button>
    @if (pages()[0] > 2) {
      <span class="pagination-ellipsis">…</span>
    }
  }

  <!-- Pages -->
  @for (p of pages(); track p) {
    <button
      class="pagination-button"
      [class.active]="p === currentPage()"
      (click)="goToPage(p)">
      {{ p }}
    </button>
  }

  <!-- Last + ellipsis -->
  @if (pages().length && pages()[pages().length - 1] < totalPages()) {
    @if (pages()[pages().length - 1] < totalPages() - 1) {
      <span class="pagination-ellipsis">…</span>
    }
    <button class="pagination-button" (click)="goToPage(totalPages())">
      {{ totalPages() }}
    </button>
  }

  <!-- Next -->
  <button
    class="pagination-button next"
    [disabled]="currentPage() === totalPages()"
    (click)="goToPage(currentPage() + 1)">
    ›
  </button>

  <!-- Per page -->
  <div class="pagination-perpage">
    <select
      class="pagination-select"
      [ngModel]="perPage()"
      (ngModelChange)="changePerPage($event)">
      <option *ngFor="let v of [10,20,30,50]" [value]="v">
        {{ v }}
      </option>
    </select>
  </div>
</div>
